import React from 'react'
import styled from '@emotion/styled'
import { fonts } from '../styles/variables'

interface Props {
	caption?: string | JSX.Element
	className?: string
}

const Figure: React.FC<Props> = ({ children, caption, className }) => (
	<figure className={className}>
		{children}
		{caption &&
			(typeof caption === 'string' ? (
				<figcaption dangerouslySetInnerHTML={{ __html: caption }} />
			) : (
				<figcaption>{caption}</figcaption>
			))}
	</figure>
)

const StyledFigure = styled(Figure)`
	figcaption {
		font-family: ${fonts.sansSerif};
		font-weight: 400;
		color: #292e38;
		margin-top: 0.4rem;
		font-size: 0.85rem;
	}
`

export default StyledFigure
